import styled from 'styled-components';
import '../../styles/_variables.scss';
import {
  UNATTEMPTED,
  ASSIGN_SELECTION,
  UNASSIGN_SELECTION,
  CORRECT,
  INCORRECT,
  ASSIGNED,
  UNAVAILABLE,
  SCHEDULED_ASSIGN
} from './utils';
import { inlineFlexbox, justifyContent, alignItems, flexbox } from '../../styles/helpers/flexbox';
import ThemeHelper from '../../themes/theme-helper';
import { Wrapper } from '../strandard-item/styled';
import { GridRow } from '../grid/styled';

const Cell = styled.span((props) => {
  let statusColor = '';
  const { status, isSelected } = props;
  let borderStyle = 'dashed';
  const { colours } = ThemeHelper.getTheme(props);

  switch (status) {
    case ASSIGNED: {
      statusColor = '#dae7d3';
      break;
    }

    case UNATTEMPTED: {
      statusColor = '#94b4c9';
      borderStyle = 'solid';
      break;
    }

    case ASSIGN_SELECTION: {
      statusColor = '#b2e4ff';
      break;
    }

    case UNASSIGN_SELECTION: {
      statusColor = '#dae7d3';
      break;
    }

    case CORRECT: {
      statusColor = '#008902';
      borderStyle = 'solid';
      break;
    }

    case INCORRECT: {
      statusColor = '#900012';
      borderStyle = 'solid';
      break;
    }

    case SCHEDULED_ASSIGN:
      statusColor = '#dae7d3';
      break;

    case UNAVAILABLE: {
      statusColor = '#c2c2c2';
      borderStyle = 'none';
      break;
    }

    default: {
      statusColor = '';
      break;
    }
  }

  return `
    width: 54px;
    min-height: 33px;
    max-height: 33px;
    box-sizing: border-box;
    ${statusColor ? `background: ${statusColor} !important;` : ''}
    border: ${isSelected ? '2px solid #00A5FF' : `1px solid ${colours.grey[400]}`};
    border-left: none;
    border-right: 1px ${borderStyle} ${colours.grey[400]};

    ${Wrapper}:first-child ${GridRow} & {
      &:first-child {
        ${isSelected ? 'border-left: 2px solid #00A5FF;' : ''}
      }
    }
    ${Wrapper}:last-child ${GridRow} & {
      &:last-child {
        ${isSelected ? 'border-right: 2px solid #00A5FF;' : ''}
      }
    }
`;
});

const ConversationStatus = styled.span`
  ${inlineFlexbox()};
  ${justifyContent('center')};
  ${alignItems('center')};

  position: relative;
  width: 54px;
  height: 28px;

  div[class*='svgIconComponent--'] {
    padding-top: 3px;

    span {
      ${flexbox()};

      svg {
        rect {
          display: none;
        }

        defs {
          path {
            fill: white;
          }
        }

        use {
          fill: white;
        }
      }
    }
  }
`;

const Circle = styled.span((props) => {
  const { colours } = ThemeHelper.getTheme(props);
  return `
    ${inlineFlexbox()};
    ${justifyContent('center')};
    ${alignItems('center')};
    content: "";
    width: 6px;
    height: 6px;
    border: 1px solid ${colours.grey[400]};
    border-radius: 50%;
    box-shadow: 0 0 1px 0 black;
    margin-top: 3px;
  `;
});

export {
  Cell,
  ConversationStatus,
  Circle
};
